<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>

        <custom-table-list :options="questions"
                           :fields="fields"
                           :is-questions="true"
                           placeholder-search="Поиск вопросов"
                           edit-link="/Admin/Questions/Edit" 
                           :apiVersion="apiHeaders['api-Version']"/>

    </div>
</template>
<script>
import Consts from '@/store/models/consts/adminConsts'

import apiService from '@/services/api.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'
import ApiHeaders from '@/store/models/ApiHeaders'

import CustomTableList from '@/components/shared/CustomTableList'

export default {
    data: function() {
        let load = new Loading();

        let apiHeaders = new ApiHeaders().mapToDto(this.$route.query['api-Version']);

        this.getQuestions(load, apiHeaders);

        return {
            load: load,
            apiHeaders: apiHeaders,

            questions: null,
            fields: [
                {   
                    key: 'OldId', 
                    label: 'ID', 
                    sortable: true
                },
                {   
                    key: 'Name', 
                    label: 'Наименование', 
                    sortable: true,
                    tdAttr: value => {
                        return { width: "40%" };
                    }
                },
                {   
                    key: 'TechnicalName', 
                    label: 'Техническое наименование', 
                    sortable: true,
                    tdAttr: value => {
                        return { width: "40%" };
                    }
                },
                {  
                    key: 'IsVisiblePolicies', 
                    label: 'Наличие условий', 
                    sortable: true,
                    formatter: value => {
                        return value ? 'Да' : 'Нет';
                    }
                },
                {   
                    key: 'IsRequired',
                    label: 'Обязательный', 
                    sortable: true,
                    formatter: value => {
                        return value ? 'Да' : 'Нет';
                    }
                },
                {   
                    key: 'Type', 
                    label: 'Тип', 
                    sortable: true,
                    formatter: value => {
                        return Consts.QuestionTypes.find(e => e.Id == value).Text;
                    }
                },
                {
                    key: 'Blocks',
                    label: 'Блоки вопросов',
                    sortable: true,
                    tdAttr: value => {
                        return { width: "35%" };
                    }
                }
            ]
        }
    },
    
    methods: {
        getQuestions: function(load, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.Questions.GetQuestions(apiHeaders)
                .then(response => {
                    this.questions = response.data;
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        }
    },

    components: {
        Spinner,
        CustomTableList
    }
}
</script>